import { UTCDeliveryPeriod } from '@epicuro-next/ataraxia/models';
import { ExtendedBasketAccountAddress } from '@epicuro-next/state/basket-state';
import { getDeliveryShopId, isDatesEqualInUTC } from '@epicuro-next/utilities';

import { BusinessState, DeliveryPeriodType } from '../../../models';

export function addFutureDeliveryPeriodReducerNew(
  state: BusinessState,
  { from }: UTCDeliveryPeriod,
  deliveryShops: ExtendedBasketAccountAddress[],
): BusinessState {
  if (!from) {
    return state;
  }

  const deliveryShopsDeliveryPeriods = deliveryShops
    ?.map((deliveryShop) => {
      const deliveryShopId = getDeliveryShopId(deliveryShop);
      const deliveryPeriodsByShop = state.deliveryPeriods[deliveryShopId] ?? {};
      const deliveryPeriodsByType =
        deliveryPeriodsByShop[DeliveryPeriodType.Future] ?? {};
      const shopAndTypeDeliveryPeriods =
        deliveryPeriodsByType.deliveryPeriods ?? [];

      const exists = shopAndTypeDeliveryPeriods?.find(
        (deliveryPeriod: string) => isDatesEqualInUTC(from, deliveryPeriod),
      );

      if (!!exists) {
        return {
          [deliveryShopId]: deliveryPeriodsByShop,
        };
      }

      return {
        [deliveryShopId]: {
          ...deliveryPeriodsByShop,
          currentDeliveryPeriodType: DeliveryPeriodType.Future,
          [DeliveryPeriodType.Future]: {
            ...deliveryPeriodsByType,
            deliveryPeriods: [...shopAndTypeDeliveryPeriods, from],
          },
        },
      };
    })
    .reduce((acc, curr) => ({ ...acc, ...curr }), {});

  return {
    ...state,
    deliveryPeriods: {
      ...deliveryShopsDeliveryPeriods,
    },
  };
}
